(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chastar-b2b-registration"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chastar-b2b-registration-native-v4')) {
    customElements.define('chastar-b2b-registration-native-v4', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => this.start());
      }

      start() {
        if (!this.isConnected || this.dataset.enhance !== 'true' || this.discovery) return;
        const config = this.querySelector('[data-cb2b-config]');
        if (!config) return;
        this.config = JSON.parse(config.textContent);
        this.roots = new Map();
        this.latestMatched = new WeakMap();
        this.boundForms = new WeakSet();
        this.pendingForms = new WeakSet();
        this.discovery = new MutationObserver(() => this.discover());
        this.discovery.observe(this.querySelector('.cb2b__app'), { childList: true, subtree: true });
        this.discover();
        customElements.whenDefined('shopify-forms-embed').then(() => {
          if (this.isConnected) this.discover();
        });
      }

      disconnectedCallback() {
        this.discovery?.disconnect();
        this.roots?.forEach(observer => observer.disconnect());
        this.discovery = null;
      }

      discover() {
        this.querySelectorAll('.cb2b__app shopify-forms-embed').forEach(embed => {
          const root = embed.shadowRoot;
          if (!root || this.roots.has(root)) return;
          const observer = new MutationObserver(() => this.enhance(root, observer));
          this.roots.set(root, observer);
          this.enhance(root, observer);
        });
      }

      normalize(text) {
        return (text || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\([^)]*\)/g, '').replace(/[^a-z0-9]/g, '');
      }

      directChild(element, parent) {
        let current = element;
        while (current && current.parentElement !== parent) current = current.parentElement;
        return current?.parentElement === parent ? current : null;
      }

      inputForLabel(root, label) {
        return (label.htmlFor && root.getElementById(label.htmlFor)) || label.querySelector('input, select, textarea') || label.parentElement?.querySelector('input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]), select, textarea');
      }

      addressType(control) {
        const values = [control.name, control.id, control.getAttribute('data-testid'), control.getAttribute('aria-controls'), control.querySelector('[id$="-selector-value"]')?.id];
        const native = values.filter(Boolean).join(' ');
        return native.match(/(?:^|[\s-])(shipping|billing)_address_/)?.[1] || null;
      }

      addressKey(control) {
        const native = [control.name, control.id, control.getAttribute('aria-controls'), control.querySelector('[id$="-selector-value"]')?.id].filter(Boolean).join(' ');
        const part = native.match(/(?:shipping|billing)_address_(first_name|last_name|recipient|phone|address1|address2|city|zip|country|zone|province)(?=$|[\s-])/);
        const parts = { first_name: 'given_name', last_name: 'family_name', recipient: 'organization', phone: 'tel', address1: 'address1', address2: 'address2', city: 'city', zip: 'postal_code', country: 'country', zone: 'province', province: 'province' };
        if (part) return parts[part[1]];
        const autocomplete = (control.getAttribute('autocomplete') || '').toLowerCase().split(/\s+/);
        const tokens = { 'given-name': 'given_name', 'family-name': 'family_name', organization: 'organization', tel: 'tel', 'address-line1': 'address1', 'address-line2': 'address2', 'postal-code': 'postal_code', 'address-level2': 'city', 'address-level1': 'province', country: 'country', 'country-name': 'country' };
        const token = autocomplete.find(value => tokens[value]);
        if (token) return tokens[token];
        const root = control.getRootNode();
        const label = control.id ? root.querySelector('label[for="' + CSS.escape(control.id) + '"]') : null;
        const text = this.normalize(label?.textContent || control.getAttribute('aria-label') || control.placeholder || native);
        if (text.includes('voornaam') || text.includes('firstname')) return 'given_name';
        if (text.includes('achternaam') || text.includes('lastname')) return 'family_name';
        if (text.includes('terattentievan') || text.includes('recipient') || text.includes('company') || text.includes('bedrijf')) return 'organization';
        if (text.includes('straatenhuisnummer') || text.includes('street') || text.includes('address1')) return 'address1';
        if (text.includes('appartement') || text.includes('suite') || text.includes('address2')) return 'address2';
        if (text.includes('postcode') || text.includes('postalcode') || text.includes('zip')) return 'postal_code';
        if (text.includes('plaats') || text.includes('stad') || text.includes('city')) return 'city';
        if (text.includes('provincie') || text.includes('province') || text.includes('regio') || text.includes('state')) return 'province';
        if (text === 'land' || text.includes('country')) return 'country';
        if (control.type === 'tel' || text.includes('telefoon') || text.includes('phone')) return 'tel';
        return null;
      }

      findAddressGroup(form, type) {
        const controls = Array.from(form.querySelectorAll('input, select, textarea, button[class*="_selectToggle_"]')).filter(node => this.addressType(node) === type);
        const checkbox = type === 'billing' ? form.querySelector('input[type="checkbox"][name="same_as_shipping_address"], input[type="checkbox"]#same_as_shipping_address') : null;
        const rows = new Set([...controls, checkbox].filter(Boolean).map(node => this.directChild(node, form)).filter(Boolean));
        let wrapper = Array.from(form.children).find(node => rows.has(node));
        const customTitle = type === 'billing' ? this.config.billing.title : this.config.groups.find(group => group.first === 'shipping_address')?.title;
        const aliases = [...this.config.addresses[type], customTitle].filter(Boolean).map(alias => this.normalize(alias));
        const titles = Array.from(form.querySelectorAll('legend, label, h2, h3, p, span')).filter(node => !node.closest('[data-cb2b-heading]') && !node.querySelector('input, select, textarea, button') && aliases.includes(this.normalize(node.textContent)));
        if (!wrapper && titles.length) wrapper = this.directChild(titles[0], form);
        if (!wrapper || ['INPUT', 'SELECT', 'TEXTAREA', 'BUTTON'].includes(wrapper.tagName)) return null;
        return { form, type, wrapper, titles, rows, checkbox };
      }

      collect(root, form) {
        const matched = new Map();
        ['shipping', 'billing'].forEach(type => {
          const group = this.findAddressGroup(form, type);
          if (group) matched.set(type + '_address', group);
        });
        const controls = Array.from(form.querySelectorAll('input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]), select, textarea')).filter(input => !this.addressType(input));
        const labels = Array.from(form.querySelectorAll('label')).filter(label => controls.includes(this.inputForLabel(root, label)));
        this.config.fields.forEach(field => {
          let label = labels.find(node => field.aliases.some(alias => this.normalize(alias) === this.normalize(node.textContent)));
          let input = label ? this.inputForLabel(root, label) : controls.find(node => [node.name, node.id, node.getAttribute('data-testid')?.replace(/^field-/, '')].some(value => (field.ids || [field.key]).includes(value)));
          if (!input && field.autocomplete) input = controls.find(node => (node.autocomplete || '').split(/\s+/).includes(field.autocomplete));
          if (!input || !controls.includes(input)) return;
          if (!label) label = labels.find(node => this.inputForLabel(root, node) === input);
          const wrapper = this.directChild(input, form);
          if (!wrapper || !label || ['INPUT', 'SELECT', 'TEXTAREA'].includes(wrapper.tagName)) return;
          matched.set(field.key, { field, input, label, wrapper });
        });
        return matched;
      }

      enhance(root, observer) {
        observer.disconnect();
        try {
          const form = root.querySelector('form[data-testid="form"]') || root.querySelector('form');
          if (!form) {
            root.querySelectorAll('[data-cb2b-heading], [data-cb2b-billing-heading], style[data-cb2b-style]').forEach(node => node.remove());
            root.querySelectorAll('.cb2b-shell').forEach(node => node.classList.remove('cb2b-shell'));
            return;
          }
          const matched = this.collect(root, form);
          this.latestMatched.set(root, matched);
          form.classList.add('cb2b-form');
          const shell = root.querySelector('[class*="_formContainer_"]') || form.parentElement;
          shell?.classList.add('cb2b-shell');
          form.querySelectorAll('label').forEach(label => {
            const input = this.inputForLabel(root, label);
            if (input && !['checkbox', 'radio', 'hidden'].includes(input.type)) label.dataset.cb2bLabel = '';
          });
          this.config.fields.forEach(field => {
            const item = matched.get(field.key);
            if (!item) return;
            item.wrapper.dataset.cb2bField = field.key;
            item.wrapper.toggleAttribute('data-cb2b-full', Boolean(field.full));
            item.label.toggleAttribute('data-cb2b-required', field.required && !item.label.textContent.includes('*'));
            if (item.input.tagName !== 'SELECT') item.input.placeholder = field.placeholder;
            if (field.autocomplete) item.input.autocomplete = field.autocomplete;
          });
          ['shipping', 'billing'].forEach(type => {
            const group = matched.get(type + '_address');
            if (!group) return;
            // Forms renders the legend, country, names, street and phone as
            // separate form children. A fieldset wrapper is optional.
            group.rows.forEach(row => {
              row.dataset.cb2bField = type + '_address';
              row.dataset.cb2bFull = '';
              row.dataset.cb2bAddressGroup = type;
            });
            group.titles.forEach(title => { title.dataset.cb2bAddressTitle = ''; });
            this.prepareAddressGroup(group, matched);
          });
          this.prepareSameAddress(form, matched);
          this.installHeadings(form, matched);
          this.installSyncHandlers(root, form);
          this.syncPartyToAddresses(matched);
          let style = root.querySelector('style[data-cb2b-style]');
          if (!style) {
            style = document.createElement('style');
            style.dataset.cb2bStyle = '';
            style.textContent = this.shadowStyles();
            root.appendChild(style);
          }
          const missing = this.config.fields.filter(field => !matched.has(field.key)).map(field => field.key);
          this.dataset.missingFields = missing.join(',');
          this.dataset.status = missing.length ? 'enhanced-partial' : matched.has('shipping_address') && matched.has('billing_address') ? 'enhanced' : 'enhanced-address-fallback';
        } finally {
          observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['placeholder', 'class', 'for', 'id', 'name'] });
        }
      }

      installHeadings(form, matched) {
        this.config.groups.forEach((group, index) => {
          const keys = group.first === 'first_name' ? ['first_name', 'last_name', 'email', 'phone'] : group.first === 'company' ? ['company', 'vat', 'kvk'] : [group.first];
          const wrappers = keys.map(key => matched.get(key)?.wrapper).filter(Boolean);
          const target = Array.from(form.children).find(node => wrappers.includes(node));
          if (!target) return;
          this.placeHeading(form, target, group.first, group.title, group.text, index === 0);
        });
        const billing = matched.get('billing_address')?.wrapper;
        const toggle = matched.get('custom_same_address')?.input;
        if (billing) this.placeHeading(form, this.directChild(toggle, form) || billing, 'billing_address', this.config.billing.title, this.config.billing.text, false);
      }

      placeHeading(form, target, key, title, text, first) {
        let heading = form.querySelector('[data-cb2b-heading="' + key + '"]');
        if (!heading) {
          heading = document.createElement('div');
          heading.dataset.cb2bHeading = key;
          const h2 = document.createElement('h2');
          const p = document.createElement('p');
          h2.textContent = title;
          p.textContent = text;
          heading.append(h2, p);
        }
        heading.classList.toggle('cb2b-heading-first', first);
        if (target.previousElementSibling !== heading) form.insertBefore(heading, target);
      }

      addressControls(group) {
        const controls = new Map();
        group.form.querySelectorAll('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), select, textarea, button[class*="_selectToggle_"]').forEach(input => {
          if (this.addressType(input) !== group.type) return;
          const key = this.addressKey(input);
          if (key && !controls.has(key)) controls.set(key, input);
        });
        return controls;
      }

      prepareAddressGroup(group, matched) {
        group.rows.forEach(row => {
          row.removeAttribute('data-cb2b-address-auto');
          row.querySelectorAll('[data-cb2b-address-auto]').forEach(node => node.removeAttribute('data-cb2b-address-auto'));
        });
        const sources = { given_name: 'first_name', family_name: 'last_name', organization: 'company', tel: 'phone' };
        const controls = this.addressControls(group);
        const rows = new Set();
        controls.forEach((control, key) => {
          const top = this.directChild(control, group.form);
          const row = group.rows.size === 1 && top?.tagName === 'FIELDSET' ? this.directChild(control, top) : top;
          if (!row) return;
          rows.add(row);
          row.dataset.cb2bAddressRow = '';
          // Include the field's label, errors and phone country selector,
          // but never a neighbouring street, postcode or city field.
          const containsOther = node => Array.from(controls).some(([part, input]) => part !== key && node.contains(input));
          let box = control.parentElement || control;
          while (box.parentElement && box.parentElement !== row && !containsOther(box.parentElement)) box = box.parentElement;
          if (!containsOther(row)) box = row;
          box.dataset.cb2bAddressField = key;
          if (sources[key] && matched.get(sources[key])?.input) {
            box.dataset.cb2bAddressAuto = '';
            return;
          }
          const example = this.config.addressFields[key];
          if (example && 'placeholder' in control) control.placeholder = example.placeholder || '';
          if (control.tagName === 'BUTTON' && example?.label) {
            let caption = box.querySelector('[data-cb2b-address-caption]');
            if (!caption) {
              caption = document.createElement('p');
              caption.dataset.cb2bAddressCaption = '';
              caption.id = (control.querySelector('[id$="-selector-value"]')?.id || control.getAttribute('aria-controls') || key) + '-cb2b-label';
              caption.textContent = example.label;
              box.insertBefore(caption, box.firstChild);
            }
            const labelledBy = (control.getAttribute('aria-labelledby') || '').split(/\s+/).filter(Boolean);
            if (!labelledBy.includes(caption.id)) control.setAttribute('aria-labelledby', [caption.id, ...labelledBy].join(' '));
          }
        });
        rows.forEach(row => {
          if (row.hasAttribute('data-cb2b-address-field')) return;
          const inputs = Array.from(controls.values()).filter(input => row.contains(input));
          if (inputs.length && inputs.every(input => input.closest('[data-cb2b-address-auto]'))) row.dataset.cb2bAddressAuto = '';
        });
      }

      prepareSameAddress(form, matched) {
        const billing = matched.get('billing_address');
        if (!billing) return;
        const native = billing.checkbox;
        if (!native) return;
        const label = native.closest('label') || (native.id && form.querySelector('label[for="' + CSS.escape(native.id) + '"]'));
        if (label) {
          label.dataset.cb2bSameAddress = '';
          const span = label.querySelector('span');
          if (span && span.textContent !== this.config.billing.sameLabel) span.textContent = this.config.billing.sameLabel;
        }
        native.setAttribute('aria-label', this.config.billing.sameLabel);
        matched.set('same_address', { input: native, label });
        const sameLabels = [this.config.billing.sameLabel, 'Hetzelfde als bezorgadres', 'Factuuradres gelijk aan bezorgadres', 'Same as shipping address'].map(text => this.normalize(text));
        const custom = Array.from(form.querySelectorAll('input[type="checkbox"]')).find(input => {
          const customLabel = input.closest('label') || (input.id && form.querySelector('label[for="' + CSS.escape(input.id) + '"]'));
          return input !== native && sameLabels.includes(this.normalize(customLabel?.textContent || input.getAttribute('aria-label')));
        });
        if (custom) {
          matched.set('custom_same_address', { input: custom });
          const customLabel = custom.closest('label') || (custom.id && form.querySelector('label[for="' + CSS.escape(custom.id) + '"]'));
          if (customLabel) customLabel.dataset.cb2bSameAddress = '';
          if (label) label.dataset.cb2bAddressAuto = '';
          if (custom.checked !== native.checked) native.click();
        }
      }

      installSyncHandlers(root, form) {
        if (this.boundForms.has(form)) return;
        this.boundForms.add(form);
        const sync = () => {
          if (this.syncing) return;
          const matched = this.collect(root, form);
          this.syncPartyToAddresses(matched);
        };
        const schedule = event => {
          if (this.syncing) return;
          const source = event.target;
          if (event.type === 'input' && source.matches('input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]), textarea')) {
            source.dispatchEvent(new source.ownerDocument.defaultView.Event('change', { bubbles: true, composed: true }));
          }
          const previous = this.latestMatched.get(root);
          const custom = previous?.get('custom_same_address')?.input;
          const native = previous?.get('same_address')?.input;
          if (event.target === custom && native && custom.checked !== native.checked) native.click();
          if (event.target === native && custom) custom.checked = native.checked;
          if (this.pendingForms.has(form)) return;
          this.pendingForms.add(form);
          queueMicrotask(() => {
            this.pendingForms.delete(form);
            if (this.isConnected && form.isConnected) sync();
          });
        };
        form.addEventListener('input', schedule);
        form.addEventListener('change', schedule);
        form.addEventListener('submit', sync, true);
        form.addEventListener('click', event => {
          if (event.target.closest('button[type="submit"]')) sync(event);
        }, true);
      }

      syncPartyToAddresses(matched) {
        if (this.syncing) return;
        this.syncing = true;
        try {
          const sources = { given_name: 'first_name', family_name: 'last_name', organization: 'company', tel: 'phone' };
          ['shipping_address', 'billing_address'].forEach(key => {
            const group = matched.get(key);
            if (!group) return;
            const controls = this.addressControls(group);
            Object.entries(sources).forEach(([part, sourceKey]) => {
              const source = matched.get(sourceKey)?.input;
              const target = controls.get(part);
              if (source && target) this.setControlValue(target, source.value);
            });
          });
        } finally {
          this.syncing = false;
        }
      }

      setControlValue(control, value) {
        if (control.value === value) return;
        if (control.type === 'tel' && control.value.replace(/\D/g, '') === value.replace(/\D/g, '')) return;
        const win = control.ownerDocument.defaultView;
        if (control.type === 'tel' && value.startsWith('+') && win.DataTransfer && win.ClipboardEvent) {
          const clipboard = new win.DataTransfer();
          clipboard.setData('text/plain', value);
          const paste = new win.ClipboardEvent('paste', { clipboardData: clipboard, bubbles: true, cancelable: true, composed: true });
          if (!control.dispatchEvent(paste)) return;
        }
        const proto = control.tagName === 'SELECT' ? win.HTMLSelectElement.prototype : control.tagName === 'TEXTAREA' ? win.HTMLTextAreaElement.prototype : win.HTMLInputElement.prototype;
        const setter = Object.getOwnPropertyDescriptor(proto, 'value')?.set;
        if (setter) setter.call(control, value);
        else control.value = value;
        control.dispatchEvent(new win.Event('input', { bubbles: true, composed: true }));
        control.dispatchEvent(new win.Event('change', { bubbles: true, composed: true }));
      }

      shadowStyles() {
        return `
          :host { --inline-container-max-width: 100%; --container-max-w: 100%; --min-form-width: 0px; --col-size: 100%; --form-field-border: 1px solid #d5d5d5; --input-label-transform: none; --form-field-border-radius: 3px; --forms-body-font: 400 16px/1.5 var(--font-body-family, Arial, sans-serif); }
          .cb2b-shell, .cb2b-shell [class*="_noImage_"], .cb2b-shell [class*="_grid_"] { width: 100% !important; max-width: none !important; min-width: 0 !important; box-sizing: border-box; }
          .cb2b-shell { margin: 0 !important; background: transparent !important; box-shadow: none !important; overflow: visible !important; }
          .cb2b-shell [class*="_gridItemContent_"] { padding: 0 !important; }
          .cb2b-shell [class*="_formHeader_"] { display: none !important; }

          form.cb2b-form { display: grid !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; gap: 24px 30px !important; padding: 0 !important; margin: 0 !important; }
          .cb2b-form > * { min-width: 0; grid-column: 1 / -1; }
          .cb2b-form > [data-cb2b-field] { grid-column: auto; align-self: start; }
          .cb2b-form > [data-cb2b-full] { grid-column: 1 / -1; }

          .cb2b-form [data-cb2b-heading],
          .cb2b-form [data-cb2b-billing-heading] { padding-top: 32px; margin-top: 8px; border-top: 1px solid #e4e4e4; text-align: left; }
          .cb2b-form .cb2b-heading-first { padding-top: 0; margin-top: 0; border-top: 0; }
          .cb2b-form [data-cb2b-heading] h2,
          .cb2b-form [data-cb2b-billing-heading] h2 { margin: 0 0 8px; color: #242424; font: 500 23px/1.3 var(--font-heading-family, Arial, sans-serif); letter-spacing: -.02em; }
          .cb2b-form [data-cb2b-heading] p,
          .cb2b-form [data-cb2b-billing-heading] p { margin: 0; font: 400 14px/1.6 var(--font-body-family, Arial, sans-serif); color: #666; }

          .cb2b-form [data-cb2b-label] { position: static !important; order: -1; display: block !important; margin: 0 0 9px !important; padding: 0 !important; max-width: none !important; width: auto !important; color: #292929 !important; font: 500 14px/1.5 var(--font-body-family, Arial, sans-serif) !important; transform: none !important; transition: none !important; pointer-events: auto !important; }
          [data-cb2b-required]::after { content: ' *'; }

          
          .cb2b-form [data-cb2b-address-auto] { display: none !important; }
          [data-cb2b-address-title],
          [data-cb2b-address-auto],
          [data-cb2b-address-auto-label] { display: none !important; }

          .cb2b-form > [data-cb2b-address-group] { display: grid !important; gap: 24px 30px !important; padding: 0 !important; margin: 0 !important; border: 0 !important; min-width: 0 !important; width: 100% !important; max-width: none !important; grid-column: 1 / -1 !important; }
          .cb2b-form [data-cb2b-address-row] { min-width: 0 !important; margin: 0 !important; }
          .cb2b-form [data-cb2b-address-row]:not([data-cb2b-address-field]) { display: grid !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; gap: 24px 30px !important; }
          .cb2b-form [data-cb2b-address-field] { min-width: 0 !important; width: auto !important; }
          .cb2b-form [data-cb2b-address-field="country"],
          .cb2b-form [data-cb2b-address-field="province"] { display: block !important; }
          .cb2b-form [data-cb2b-address-caption] { margin: 0 0 9px !important; color: #292929; font: 500 14px/1.5 var(--font-body-family, Arial, sans-serif); }
          .cb2b-form [data-cb2b-address-group] button[class*="_selectToggle_"] { min-height: 52px !important; width: 100% !important; box-sizing: border-box !important; padding: 13px 15px !important; border: 1px solid #d5d5d5 !important; border-radius: 3px !important; background: #fff !important; color: #242424 !important; font-size: 16px !important; }
          .cb2b-form [data-cb2b-address-group] input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]),
          .cb2b-form [data-cb2b-address-group] select,
          .cb2b-form [data-cb2b-address-group] textarea { width: 100% !important; min-width: 0 !important; min-height: 52px !important; box-sizing: border-box !important; padding: 13px 15px !important; color: #242424 !important; font-size: 16px !important; border: 1px solid #d5d5d5 !important; border-radius: 3px !important; background: #fff !important; }

          
          .cb2b-form [data-cb2b-same-address],
          .cb2b-form [data-cb2b-address-group="billing"] label:has(input[type="checkbox"]) { display: flex !important; align-items: flex-start !important; gap: 11px !important; margin: 2px 0 0 !important; color: #292929 !important; font: 500 14px/1.5 var(--font-body-family, Arial, sans-serif) !important; cursor: pointer; }
          .cb2b-form [data-cb2b-address-group="billing"] input[type="checkbox"] { width: 18px !important; height: 18px !important; min-width: 18px !important; margin: 1px 0 0 !important; accent-color: var(--cb2b-accent, #242424); cursor: pointer; }

          .cb2b-form [data-cb2b-address-group="billing"] [data-cb2b-same-address][data-cb2b-address-auto] { display: none !important; }

          .cb2b-form [data-cb2b-field="phone"] { display: grid !important; grid-template-columns: minmax(0, 90px) minmax(0, 1fr) !important; gap: 0 8px !important; }
          .cb2b-form [data-cb2b-field="phone"] > :first-child { grid-column: 1; grid-row: 2; align-self: start; min-height: 52px; }
          .cb2b-form [data-cb2b-field="phone"] [class*="_formFieldContainer_"] { display: contents !important; }
          .cb2b-form [data-cb2b-field="phone"] [data-cb2b-label] { grid-column: 1 / -1; grid-row: 1; }
          .cb2b-form [data-cb2b-field="phone"] input[type="tel"] { grid-column: 2; grid-row: 2; }

          .cb2b-form [data-cb2b-field="phone"] .phone-country-selector button[class*="_selectToggle_"] { min-height: 52px !important; width: 100% !important; box-sizing: border-box !important; padding: 13px 10px !important; border: 1px solid #d5d5d5 !important; border-radius: 3px !important; background: #fff !important; }

          .cb2b-form input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]),
          .cb2b-form select,
          .cb2b-form textarea { width: 100% !important; min-width: 0 !important; min-height: 52px; box-sizing: border-box; padding: 13px 15px !important; color: #242424 !important; font-size: 16px !important; border: 1px solid #d5d5d5; border-radius: 3px; background: #fff; }
          .cb2b-form input::placeholder, .cb2b-form textarea::placeholder { color: #707070 !important; opacity: 1 !important; }
          .cb2b-form input:focus-visible, .cb2b-form select:focus-visible, .cb2b-form button:focus-visible { outline: 2px solid var(--cb2b-accent, #242424) !important; outline-offset: 3px !important; }
          .cb2b-form [aria-invalid="true"] { border-color: #ab2525 !important; }
          .cb2b-form button[type="submit"] { justify-self: start; min-height: 52px; padding: 14px 30px !important; box-sizing: border-box; background: var(--cb2b-accent, #242424) !important; color: #fff !important; border-radius: 3px !important; font-size: 15px !important; line-height: 1.5 !important; }
          .cb2b-form button[type="submit"]:disabled { opacity: .65; cursor: wait; }
          .cb2b-shell [class*="_formDisclaimer_"] { font-size: 12px !important; line-height: 1.6 !important; text-align: left !important; padding: 0 !important; }

          /* Keep these rules after the row and checkbox display rules. */
          .cb2b-form [data-cb2b-address-title],
          .cb2b-form [data-cb2b-address-group][data-cb2b-address-auto],
          .cb2b-form [data-cb2b-address-group] [data-cb2b-address-auto] { display: none !important; }

          @media (max-width: 749px) {
            .cb2b-form [data-cb2b-address-row]:not([data-cb2b-address-field]) { grid-template-columns: minmax(0, 1fr) !important; gap: 20px !important; }
            .cb2b-form > [data-cb2b-address-group] { gap: 20px !important; }
            form.cb2b-form { grid-template-columns: minmax(0, 1fr) !important; gap: 20px !important; }
            .cb2b-form [data-cb2b-heading], .cb2b-form [data-cb2b-billing-heading] { padding-top: 26px; }
            .cb2b-form .cb2b-heading-first { padding-top: 0; }
            .cb2b-form button[type="submit"] { width: 100% !important; }
          }
        `;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chastar-brand-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chastar-brand-story')) {
    customElements.define('chastar-brand-story', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.controller) return;
          this.track = this.querySelector('.cbs__track');
          this.cards = Array.from(this.querySelectorAll('.cbs__card'));
          this.dots = Array.from(this.querySelectorAll('.cbs__dot'));
          this.navigation = this.querySelector('.cbs__dots');
          if (!this.track || !this.cards.length) return;
          this.controller = new AbortController();
          const signal = this.controller.signal;
          this.schedule = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = 0;
              this.update();
            });
          };
          this.track.addEventListener('scroll', this.schedule, { passive: true, signal });
          this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index), { signal }));
          this.track.addEventListener('keydown', event => {
            if (event.target !== this.track || !this.scrollable) return;
            const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
            let target;
            if (event.key === 'ArrowRight') target = this.active + direction;
            if (event.key === 'ArrowLeft') target = this.active - direction;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = this.cards.length - 1;
            if (target === undefined) return;
            event.preventDefault();
            this.goTo(Math.max(0, Math.min(target, this.cards.length - 1)));
          }, { signal });
          this.addEventListener('shopify:block:select', event => {
            const index = this.cards.findIndex(card => card.dataset.blockId === event.detail?.blockId);
            if (index !== -1) this.goTo(index);
          }, { signal });
          this.observer = new ResizeObserver(this.schedule);
          this.observer.observe(this.track);
          this.update();
        });
      }
      anchor(element, style) {
        const rect = element.getBoundingClientRect();
        return style.direction === 'rtl' ? rect.right : rect.left;
      }
      update() {
        const style = getComputedStyle(this.track);
        const rtl = style.direction === 'rtl';
        const padding = parseFloat(rtl ? style.paddingRight : style.paddingLeft) || 0;
        const origin = this.anchor(this.track, style) + (rtl ? -padding : padding);
        this.scrollable = this.track.scrollWidth > this.track.clientWidth + 2;
        if (this.navigation) this.navigation.hidden = !this.scrollable;
        if (this.scrollable) this.track.setAttribute('tabindex', '0');
        else this.track.removeAttribute('tabindex');
        let closest = Infinity;
        this.active = 0;
        this.cards.forEach((card, index) => {
          const distance = Math.abs(this.anchor(card, style) - origin);
          if (distance < closest) { closest = distance; this.active = index; }
        });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.active)));
      }
      goTo(index) {
        if (!this.scrollable || !this.cards[index]) return;
        const style = getComputedStyle(this.track);
        const rtl = style.direction === 'rtl';
        const padding = parseFloat(rtl ? style.paddingRight : style.paddingLeft) || 0;
        const origin = this.anchor(this.track, style) + (rtl ? -padding : padding);
        const delta = this.anchor(this.cards[index], style) - origin;
        this.track.scrollTo({
          left: this.track.scrollLeft + delta,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chastar-showrooms"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chastar-showrooms')) {
    customElements.define('chastar-showrooms', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.mapObserver?.disconnect();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const tabs = Array.from(this.querySelectorAll('[data-showroom-tab]'));
        const panels = Array.from(this.querySelectorAll('[data-showroom-panel]'));
        if (!panels.length) return;
        const loadMaps = (panel) => {
          panel.querySelectorAll('[data-showroom-map]').forEach((frame) => {
            if (!frame.hasAttribute('src') && frame.dataset.src) frame.src = frame.dataset.src;
          });
        };
        if ('IntersectionObserver' in window) {
          this.mapObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !entry.target.hidden) {
                loadMaps(entry.target);
                this.mapObserver.unobserve(entry.target);
              }
            });
          }, { rootMargin: '200px 0px' });
          panels.forEach((panel) => this.mapObserver.observe(panel));
        } else {
          loadMaps(panels[0]);
        }
        if (tabs.length < 2 || panels.length !== tabs.length) return;
        this.setAttribute('data-enhanced', '');
        this.querySelector('[data-showroom-tabs]').setAttribute('role', 'tablist');
        tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panels[index].id);
          panels[index].setAttribute('role', 'tabpanel');
          panels[index].setAttribute('aria-labelledby', tab.id);
        });
        const activate = (index, focus = false) => {
          tabs.forEach((tab, current) => {
            const selected = current === index;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            panels[current].hidden = !selected;
            panels[current].tabIndex = selected ? 0 : -1;
            if (selected && !this.mapObserver) loadMaps(panels[current]);
          });
          if (focus) {
            tabs[index].focus({ preventScroll: true });
            tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', (event) => {
            event.preventDefault();
            activate(index);
          }, options);
          tab.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              activate(index);
              return;
            }
            const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
            let next = index;
            if (event.key === 'ArrowRight') next = (index + direction + tabs.length) % tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - direction + tabs.length) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else return;
            event.preventDefault();
            activate(next, true);
          }, options);
        });
        document.addEventListener('shopify:block:select', (event) => {
          if (!this.contains(event.target)) return;
          const index = panels.findIndex((panel) => panel.dataset.blockId === event.detail?.blockId);
          if (index !== -1) activate(index);
        }, options);
        activate(0);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.mapObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
